import { Component, Input, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { ToastrService } from "ngx-toastr";
import { Helpers } from "../../../helpers";
import { appService } from "../../../_services/app.service";
import { ITableModel } from '../../../../../src/app/shared/components/table/model/tableModel';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { CommonService } from '../../../_services/common.service';

@Component({
  selector: 'app-ftl-cost-sheet',
  templateUrl: './ftl-cost-sheet.component.html',
  styleUrls: ['./ftl-cost-sheet.component.scss']
})
export class FtlCostSheetComponent implements OnInit {
  CompanyId: any;
  OrderId: any = null;
  TripId: any = null;

  incomeTableDetails: ITableModel;
  expenseTableDetails: ITableModel;
  incomeData: any = [];
  expenseData: any = [];
  incomeExpenseTotal: any = { incomeActualTotal: 0, incomeEstimatedTotal: 0, expenseActualTotal: 0, expenseEstimatedTotal: 0 }

  //Added By Burhan - 23-Jan-2026
  canViewIncomeDetails: Boolean;
  canAddIncomeDetails: Boolean;
  canViewExpenseDetails: Boolean;
  canAddExpenseDetails: Boolean;
  //ApprovalTypeScreenCode: any = 'ASSIGN_VEHICLE_DETAILS'
  //end by Burhan - 23-Jan-2026
  isDetailsPageShow: any;
  totalOrderCount: any;
  modalRef: NgbModalRef | null = null;
  @ViewChild("tripExpense") tripExpense: TemplateRef<any>;
  @Input() IndentId: any;
  @Input() ScreenName: any;
  @Input() OrderNo: any;
  @Input() BookingId: any;
  @Input() TransporterId: any;
  @Input() CustomerId: any;
  @Input() ConsignmentNo: any;

  constructor(
    private toastr: ToastrService,
    private _appService: appService,
    private modalService: NgbModal,
    private commonService: CommonService,//add by burhan - 23-Jan-2026
  ) { }

  ngOnInit() {
    this.initalizeForm();
    this.AssignScreenCodeAsPerApprovalType();
  }

  async initalizeForm() {
    this.incomeTableDetails = {
      emptyDataMSg: 'No Data Found',
      data: [],
      columnDetails: [
        { columnName: 'Bill To', dataFieldName: 'billToParty', whitespace: 'nowrap'  ,width: "5%" },
        { columnName: 'Vehicle Type', dataFieldName: 'VehicleType', whitespace: 'nowrap',width: "5%" },
        { columnName: 'Charge', dataFieldName: 'chargeCode', whitespace: 'nowrap',width: "20%" },
        { columnName: 'Consignment', dataFieldName: 'ConsignmentNo', whitespace: 'nowrap',width: "5%" },
        { columnName: 'Order No', dataFieldName: 'ConsignmentWiseOrderNo', whitespace: 'nowrap',width: "5%" },
        { columnName: 'Quote Status', dataFieldName: 'QuotationStatus', whitespace: 'nowrap',width: "5%" }, //added by fahim 12-01-2026 :)

        { columnName: 'Based On', dataFieldName: 'extimatedUnit', whitespace: 'nowrap' ,width: "5%"},
        { columnName: 'Qty', dataFieldName: 'extimatedQty', whitespace: 'nowrap',alignType:'right',width: "5%" },
        { columnName: 'Rate', dataFieldName: 'extimatedRate', whitespace: 'nowrap' ,alignType:'right',width: "5%"},
        { columnName: 'GST', dataFieldName: 'extimatedGst', whitespace: 'nowrap',alignType:'right',width: "5%" },
        { columnName: 'Estimated', dataFieldName: 'extimatedAmount', whitespace: 'nowrap' ,alignType:'right',width: "10%",divType:'toshowvaluewithDecimals'},
        { columnName: 'GST Amount', dataFieldName: 'gstAmount', whitespace: 'nowrap' ,alignType:'right',width: "5%",divType:'toshowvaluewithDecimals'},
        { columnName: 'NetAmount', dataFieldName: 'netAmount', whitespace: 'nowrap' ,alignType:'right',width: "10%",divType:'toshowvaluewithDecimals'},

        { columnName: 'Based On', dataFieldName: 'actualUnit', whitespace: 'nowrap' ,width: "5%"},
        { columnName: 'Qty', dataFieldName: 'actualQty', whitespace: 'nowrap',alignType:'right',width: "5%" },
        { columnName: 'Rate', dataFieldName: 'actualRate', whitespace: 'nowrap',alignType:'right',width: "5%" },
        { columnName: 'GST', dataFieldName: 'actualGst', whitespace: 'nowrap',alignType:'right',width: "5%" },
        { columnName: 'Actual', dataFieldName: 'actualAmount', whitespace: 'nowrap',alignType:'right',width: "5%",divType:'toshowvaluewithDecimals'},
        { columnName: 'Refe. No', dataFieldName: 'actualRefNo', whitespace: 'nowrap',alignType:'right',width: "5%" },
      ],
      columnDetails2: [
        { columnName: 'Income', dataFieldName: 'Income', colspan: 6 },
        { columnName: 'Estimated', dataFieldName: 'Estimated', colspan: 7 },
        { columnName: 'Actual', dataFieldName: 'Actual', colspan: 6 }
      ],
      footerData: [
        {
          BillTo: "Total", Contracted: '', Charge: '', Consignment: '', OrderNo: ''
          , extimatedUnit: '', extimatedQty: '', extimatedRate: '', extimatedGst: '', extimatedAmount: ''
          , actualUnit: '', actualQty: '', actualRate: '', actualGst: '', actualAmount: '', actualRefNo: ''
        },
      ],
      actionList: [],
      isColumnNameShow: true,
      isShowFooterData: true
    };
    this.expenseTableDetails = {
      emptyDataMSg: 'No Data Found',
      data: [],
      columnDetails: [
        { columnName: 'Bill To', dataFieldName: 'billToParty', whitespace: 'nowrap',width: "5%" },
        { columnName: 'Vehicle Type', dataFieldName: 'VehicleType', whitespace: 'nowrap' ,width: "5%"},
        { columnName: 'Charge', dataFieldName: 'chargeCode', whitespace: 'nowrap',width: "20%" },
        { columnName: 'Consignment', dataFieldName: 'ConsignmentNo', whitespace: 'nowrap',width: "5%" },
        { columnName: 'Order No', dataFieldName: 'orderNo', whitespace: 'nowrap',width: "5%" },
        { columnName: 'Quote Status', dataFieldName: 'QuotationStatus', whitespace: 'nowrap',width: "5%" }, //added by fahim 12-01-2026 :)

        { columnName: 'Based On', dataFieldName: 'extimatedUnit', whitespace: 'nowrap' ,width: "5%"},
        { columnName: 'Qty', dataFieldName: 'extimatedQty', whitespace: 'nowrap',alignType:'right',width: "5%" },
        { columnName: 'Rate', dataFieldName: 'extimatedRate', whitespace: 'nowrap',alignType:'right',width: "5%" },
        { columnName: 'GST', dataFieldName: 'extimatedGst', whitespace: 'nowrap',alignType:'right' ,width: "5%"},
        { columnName: 'Estimated', dataFieldName: 'extimatedAmount', whitespace: 'nowrap',alignType:'right',width: "10%" ,divType:'toshowvaluewithDecimals'},
        { columnName: 'GST Amount', dataFieldName: 'gstAmount', whitespace: 'nowrap' ,alignType:'right',width: "5%",divType:'toshowvaluewithDecimals'},
        { columnName: 'NetAmount', dataFieldName: 'netAmount', whitespace: 'nowrap' ,alignType:'right',width: "10%",divType:'toshowvaluewithDecimals'},

        { columnName: 'Based On', dataFieldName: 'actualUnit', whitespace: 'nowrap',width: "5%" },
        { columnName: 'Qty', dataFieldName: 'actualQty', whitespace: 'nowrap',alignType:'right' ,width: "5%"},
        { columnName: 'Rate', dataFieldName: 'actualRate', whitespace: 'nowrap' ,alignType:'right',width: "5%"},
        { columnName: 'GST', dataFieldName: 'actualGst', whitespace: 'nowrap',alignType:'right' ,width: "5%"},
        { columnName: 'Actual', dataFieldName: 'actualAmount', whitespace: 'nowrap' ,alignType:'right',width: "5%",divType:'toshowvaluewithDecimals'},
        { columnName: 'Refe. No', dataFieldName: 'actualRefNo', whitespace: 'nowrap',alignType:'right' ,width: "5%"},
      ],
      columnDetails2: [
        { columnName: 'Expense', dataFieldName: 'Expense', colspan: 6 },
        { columnName: 'Estimated', dataFieldName: 'ExpenseEstimated', colspan: 7 },
        { columnName: 'Actual', dataFieldName: 'ExpenseActual', colspan: 6 }
      ],
      footerData: [
        {
          BillTo: "Total", Contracted: '', Charge: '', Consignment: '', OrderNo: ''
          , extimatedUnit: '', extimatedQty: '', extimatedRate: '', extimatedGst: '', extimatedAmount: '', netAmount:'', gstAmount:''
          , actualUnit: '', actualQty: '', actualRate: '', actualGst: '', actualAmount: '', actualRefNo: ''
        },
        // {
        //   billToParty: "Profit & Loss", Contracted: '', Charge: '', Consignment: '', OrderNo: ''
        //   , extimatedUnit: '', extimatedQty: '', extimatedRate: '', extimatedGst: '', extimatedAmount: '', netAmount:'', gstAmount:''
        //   , actualUnit: '', actualQty: '', actualRate: '', actualGst: '', actualAmount: '', actualRefNo: ''
        // },
      ],
      actionList: [],
      isColumnNameShow: true,
      isShowFooterData: true
    };
  }

  GetCostData() {
    Helpers.setLoading(true);
    if (this.OrderId == null && this.TripId == null) {
      this.toastr.warning("Please select order or trip !", "warning");
      Helpers.setLoading(false);
      return false;
    }
    this.incomeData = [];
    this.expenseData = [];
    this.incomeExpenseTotal = { incomeActualTotal: 0, incomeEstimatedTotal: 0, expenseActualTotal: 0, expenseEstimatedTotal: 0 }
    this._appService.GetByThreeId("OrdersByVehicle", "acr_GetOrderTripWise_GeneralLedger", this.CompanyId, this.OrderId, this.TripId).subscribe((response) => {
      this.incomeData = response.Table;
      this.expenseData = response.Table1;

      for (const item of this.incomeData) {
        this.incomeExpenseTotal.incomeActualTotal = this.incomeExpenseTotal.incomeActualTotal + item.actualAmount;
        this.incomeExpenseTotal.incomeEstimatedTotal = this.incomeExpenseTotal.incomeEstimatedTotal + item.extimatedAmount;
      }

      for (const item of this.expenseData) {
        this.incomeExpenseTotal.expenseActualTotal = this.incomeExpenseTotal.expenseActualTotal + item.actualAmount;
        this.incomeExpenseTotal.expenseEstimatedTotal = this.incomeExpenseTotal.expenseEstimatedTotal + item.extimatedAmount;
      }

      this.incomeExpenseTotal.incomeActualTotal = parseFloat(this.incomeExpenseTotal.incomeActualTotal).toFixed(2);
      this.incomeExpenseTotal.incomeEstimatedTotal = parseFloat(this.incomeExpenseTotal.incomeEstimatedTotal).toFixed(2);
      this.incomeExpenseTotal.expenseActualTotal = parseFloat(this.incomeExpenseTotal.expenseActualTotal).toFixed(2);
      this.incomeExpenseTotal.expenseEstimatedTotal = parseFloat(this.incomeExpenseTotal.expenseEstimatedTotal).toFixed(2);

      this.incomeTableDetails.data = this.incomeData;
      this.incomeTableDetails.footerData[0].extimatedAmount = this.incomeExpenseTotal.incomeEstimatedTotal;
      this.incomeTableDetails.footerData[0].actualAmount = this.incomeExpenseTotal.incomeActualTotal;

      this.expenseTableDetails.data = this.expenseData;
      this.expenseTableDetails.footerData[0].extimatedAmount = this.incomeExpenseTotal.expenseEstimatedTotal;
      this.expenseTableDetails.footerData[0].actualAmount = this.incomeExpenseTotal.expenseActualTotal;

      const ProfitextimatedAmount = (this.incomeExpenseTotal.incomeEstimatedTotal - this.incomeExpenseTotal.expenseEstimatedTotal).toFixed(2);
      const ProfitactualAmount = (this.incomeExpenseTotal.incomeActualTotal - this.incomeExpenseTotal.expenseActualTotal).toFixed(2);

      // Profit & Loss row sirf tab set karo jab exist karta ho
      if (this.expenseTableDetails.footerData && this.expenseTableDetails.footerData.length > 1) {
        this.expenseTableDetails.footerData[1].extimatedAmount = ProfitextimatedAmount;
        this.expenseTableDetails.footerData[1].actualAmount = ProfitactualAmount;
      }


      let amt:0;
      let inctotalNetAmount = 0;
      let inctotalgstAmount = 0;
      this.incomeTableDetails.data.forEach((element) => {
          inctotalNetAmount += Number(element.netAmount) || 0
          inctotalgstAmount += Number(element.gstAmount) || 0
      })
      
      let exptotalNetAmount = 0;
      let exptotalgstAmount = 0;
      this.expenseTableDetails.data.forEach((element) => {
          exptotalNetAmount += Number(element.netAmount) || 0
          exptotalgstAmount += Number(element.gstAmount) || 0
      })
      
      this.incomeTableDetails.footerData[0].netAmount = inctotalNetAmount;
      this.expenseTableDetails.footerData[0].netAmount = exptotalNetAmount;
      this.incomeTableDetails.footerData[0].gstAmount = inctotalgstAmount;
      this.expenseTableDetails.footerData[0].gstAmount = exptotalgstAmount;
      
      this.incomeTableDetails.footerData[0].netAmount = parseFloat(this.incomeTableDetails.footerData[0].netAmount).toFixed(2);
      this.expenseTableDetails.footerData[0].netAmount = parseFloat(this.expenseTableDetails.footerData[0].netAmount).toFixed(2);
      this.incomeTableDetails.footerData[0].gstAmount = parseFloat(this.incomeTableDetails.footerData[0].gstAmount).toFixed(2);
      this.expenseTableDetails.footerData[0].gstAmount = parseFloat(this.expenseTableDetails.footerData[0].gstAmount).toFixed(2);
      Helpers.setLoading(false);
    },
      (err) => {
        Helpers.setLoading(false);
        this.toastr.error("Error occurred while fetching Data !", "error");
      }
    );
  }

  onActionClick(event) {}

  onPageNumberChange(event) {}

  onPageChange(event) {}

  GetSelectedRow(event) {}

  goToDetailsPage(event) {}

  NewButtonHandle(event){
    console.log('NewButtonHandle in costsheet',event);
    console.log(`'IndentId in costsheet',${this.IndentId},'ScreenName in costsheet',${this.ScreenName},'OrderNo in costsheet',${this.OrderNo},'BookingId in costsheet',${this.BookingId},`);
    if(event.event.trim()==='Trip Expense' && (this.BookingId === null || this.BookingId === undefined)){
      this.toastr.warning('Expense recording is permitted only after the trip is generated and assigned to a transporter. For contracted or ad-hoc bid transporters, the system automatically retrieves the approved rates once the vehicle is assigned.','Warning')
      return;
    }
    if(event.event.trim()==='Trip Expense'){
      this.modalRef = this.modalService.open(this.tripExpense, { centered: true, size: "lg", windowClass: "modal-xl-custom" });
    }else if(event.event.trim()==='Record Income'){
      this.modalRefRI = this.modalService.open(this.recordIncome, { centered: true, size: "lg", windowClass: "modal-xl-custom" });
    }

  }

  closeModalTripExpense() {
    this.modalRef.close();
    this.GetCostData();
  }

  modalRefRI: NgbModalRef | null = null;
  @ViewChild("recordIncome") recordIncome: TemplateRef<any>;
  closeModalRI() {
    this.modalRefRI.close();
    this.GetCostData();
  }

  //Added By Burhan - 23-Jan-2026 - BUR-JAN26-017
  AssignScreenCodeAsPerApprovalType() {

    this.canViewIncomeDetails = this.commonService.CheckHasRight('VIEW', 'INCOME_DETAILS');
    this.canAddIncomeDetails = this.commonService.CheckHasRight('ADD', 'INCOME_DETAILS');


    this.canViewExpenseDetails = this.commonService.CheckHasRight('VIEW', 'EXPENSE_DETAILS');
    this.canAddExpenseDetails = this.commonService.CheckHasRight('ADD', 'EXPENSE_DETAILS');

    if(this.canViewIncomeDetails && this.canViewExpenseDetails){
      this.expenseTableDetails.footerData.push(
        {
          billToParty: "Profit & Loss", Contracted: '', Charge: '', Consignment: '', OrderNo: ''
          , extimatedUnit: '', extimatedQty: '', extimatedRate: '', extimatedGst: '', extimatedAmount: '', netAmount:'', gstAmount:''
          , actualUnit: '', actualQty: '', actualRate: '', actualGst: '', actualAmount: '', actualRefNo: ''
        }
      )
    }


    console.log("CanViewIncome:",this.canViewIncomeDetails," CanAddIncome:",this.canAddIncomeDetails);
    console.log("CanViewExpense:",this.canViewExpenseDetails," CanAddExpense:",this.canAddExpenseDetails);

  }
  //end by burhan - 23-Jan-2026
}
